import * as React from "react";
import classnames from "classnames";
const OpeningHoursSpecial = ({ special, amountToDisplay }) => /* @__PURE__ */ React.createElement("dl", { className: "location-opening-hours__list" }, special.slice(0, amountToDisplay).map(({ label, status, entries }) => /* @__PURE__ */ React.createElement(React.Fragment, { key: label }, /* @__PURE__ */ React.createElement("dt", { className: classnames("location-opening-hours__day") }, label), /* @__PURE__ */ React.createElement(
  "dd",
  {
    className: classnames("location-opening-hours__hours", {
      "location-opening-hours--closed": status === "CLOSED"
    })
  },
  entries.map(({ key, value }) => /* @__PURE__ */ React.createElement("span", { key, className: "location-opening-hours__hours-entry" }, value))
))));
export {
  OpeningHoursSpecial as default
};
//# sourceMappingURL=OpeningHoursSpecial.js.map
